module.exports = __webpack_public_path__ + "img/portugal-logo-icon.32694392.png";